// extracted by mini-css-extract-plugin
export var quantityInput = "_ef-0";